module.exports = __webpack_public_path__ + "static/media/Comments.11c6e2b7.svg";